import { DocumentType, IssuerType } from "@dune/types";
import { fileTypeAndIssuerMapping } from "@dune/vars";

export const FILE_NAME_FORBIDDEN_CHARS_REGEX = /^[^<>:"\/\\|?*]+$/;
export const FILE_NAME_MAX_LENGTH = 255;

export const validateFileName = (value: string): string | null => {
	const trimmed = value.trim();
	if (trimmed.length === 0) {
		return "Le nom du fichier ne peut pas être vide";
	}
	if (trimmed.length > FILE_NAME_MAX_LENGTH) {
		return `Le nom du fichier ne peut pas dépasser ${FILE_NAME_MAX_LENGTH} caractères`;
	}
	if (!FILE_NAME_FORBIDDEN_CHARS_REGEX.test(trimmed)) {
		return "Le nom du fichier contient des caractères interdits";
	}
	return null;
};

export const getLabelAndSchemaFromFileTypeAndIssuer = (type: DocumentType, issuer?: IssuerType | null) => {
  const withTypeOnly = fileTypeAndIssuerMapping[type];

  if (withTypeOnly && "schema" in withTypeOnly) {
    return withTypeOnly;
  }

  if (!issuer) {
    return { label: "", schema: {} };
  }

  const withTypeAndIssuer = withTypeOnly[issuer];

  if (withTypeAndIssuer && "schema" in withTypeAndIssuer) {
    return withTypeAndIssuer;
  }

  return { label: "", schema: {} };
};